<template>
        <router-link
            :to="{ name: 'event.view', params: { id: event.id, slug: event.slug } }"
            class="border-t last:border-b border-black block"
        >
            <div ref="moleculeCardEvent">
                <!-- MOBILE -->
                <div class="p-4 space-y-10 md:hidden">
                    <div class="flex items-">
                        <div class="min-w-[100px] text-2xl">
                            <p>{{ formatDate(event.finishing_date, "DD.MM") }}</p>
                            <p class="text-grey">{{ formatDate(event.finishing_date, "YY") }}</p>
                        </div>

                        <div class="text-2xl">
                            {{ event.name }}
                        </div>
                    </div>

                    <div class="flex items-top justify-between">
                        <div class="flex flex-col justify-between">
                            <div class="flex flex-wrap gap-2 h-fit">
                                <div
                                    v-for="type in event.types" :key="type.id"
                                    class="border border-black px-2 py-1 rounded-lg"
                                >
                                    {{ type.name }}
                                </div>
                            </div>
                            <div>
                                {{ event.place}}
                            </div>
                        </div>

                        <img class="w-28 h-28 rounded-md shrink-0 object-cover" :src="event.cover.cached_url" alt="">
                    </div>

                    <p class="line-clamp-3" v-html="event.description"></p>
                </div>
                <!-- END MOBILE -->

                <!-- DESKTOP -->
                <div class="hidden md:flex hover:bg-pink group hover:!text-white transition duration-200 ease-in-out hover:cursor-pointer">
                    <div class="border-r border-black w-1/3">
                        <div class="flex justify-between px-4 lg:px-12 py-6 h-full">
                            <img class="w-28 h-28 rounded-md shrink-0 object-cover aspect-square" :src="event.cover.cached_url" alt="">
                            <div class="text-3xl text-right">
                                <p>{{ formatDate(dateToDisplay, "DD.MM") }}</p>
                                <p class="text-grey">{{ formatDate(dateToDisplay, "YY") }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="w-2/3">
                        <div class="px-4 lg:px-12 py-6">
                            <div class="flex justify-between">
                                <div class="text-2xl w-1/2 pr-12 shrink-0">
                                    {{ event.name }}
                                </div>
                                <div>
                                    <p class="line-clamp-5" v-html="event.description"></p>
                                </div>
                            </div>
                            <div class="flex flex-wrap h-fit mt-2 items-center mt-4">
                                <div class="w-1/2 flex flex-wrap gap-2 pr-4">
                                    <div
                                        v-for="type in event.types" :key="type.id"
                                        class="border border-black group-hover:border-white px-2 py-1 rounded-lg w-fit"
                                    >
                                        {{ type.name }}
                                    </div>
                                </div>
                                <div class="w-1/2 text-xs">
                                    {{ event.place}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END DESKTOP -->
            </div>
        </router-link>
</template>

<script>
import {formatDate} from "../../../utils/formatDate";

export default {
    name: 'MoleculeCardEvent',
    props: {
        event: null,
    },
    mounted() {
        // Hack used to update the color of <br> in the description when they are clamped.
        this.hack();
    },
    methods: {
        formatDate,
        hack() {
            const eventDescription = this.$refs.moleculeCardEvent;
            const refreshCss = () => {
                document.body.style.zoom = 1.0000001;
                setTimeout(() => {
                    document.body.style.zoom = 1.0000000;
                },200);
            };

            eventDescription.addEventListener("mouseenter", refreshCss);

            eventDescription.addEventListener("mouseleave", refreshCss);
        },
    },
    computed: {
        dateToDisplay() {
            return this.isUpcoming ? this.event.starting_date : this.event.finishing_date;
        },

        isUpcoming() {
            const currentDate = new Date();
            const eventDate = new Date(this.event.finishing_date);
            return eventDate >= currentDate;
        }
    }
}
</script>
